import React from "react";
import { Link } from "react-router-dom";
import "../productMaster/productMaster.scss";
import product from "../../assets/images/product12.png";
import { NotFound } from "../../components/common/NotFound";
import DeleteModal from "../../components/common/DeleteModal";

const ProductMasterList = () => {
  return (
    <div className="container-fluid product-catalogue-list-sec">
      {/* <!-- filter-area-sec starts --> */}
      <section className="filter-area-sec mt-3">
        <div className="card">
          <div className="card-body">
            <div className="row">
              <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <div className="row">
                  <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-12 col-xs-12 left-filter-column">
                    <div className="form-group has-search">
                      <span className="fa fa-search form-control-feedback"></span>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Search Product"
                      />
                    </div>
                    <div>
                      <button className="btn">
                        Products
                        <span className="float-right">5 Products Found</span>
                      </button>
                    </div>

                    <div id="main">
                      <div className="accordion mt-2" id="productsType">
                        <div className="card">
                          <div className="card-header" id="fireRatingHead">
                            <a
                              href="#"
                              className="btn btn-header-link"
                              data-toggle="collapse"
                              data-target="#fireRating"
                              aria-expanded="true"
                              aria-controls="fireRating"
                            >
                              Main Category
                            </a>
                          </div>

                          <div
                            id="fireRating"
                            className="collapse show mt-1"
                            aria-labelledby="fireRatingHead"
                            data-parent="#productsType"
                          >
                            <div className="card-body">
                              <div className="custom-control custom-checkbox custom-checkbox-blue">
                                <input
                                  type="checkbox"
                                  className="custom-control-input custom-control-input-blue"
                                  id="customCheck1"
                                />
                                <label
                                  className="custom-control-label pt-1"
                                  for="customCheck1"
                                >
                                  1.5 Hour Rated Fire Dampers
                                </label>
                              </div>
                              <div className="custom-control custom-checkbox custom-checkbox-blue">
                                <input
                                  type="checkbox"
                                  className="custom-control-input custom-control-input-blue"
                                  id="customCheck2"
                                />
                                <label
                                  className="custom-control-label pt-1"
                                  for="customCheck2"
                                >
                                  3 Hour Rated Fire Dampers
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="card">
                          <div className="card-header" id="applicationHead">
                            <a
                              href="#"
                              className="btn btn-header-link collapsed"
                              data-toggle="collapse"
                              data-target="#application"
                              aria-expanded="true"
                              aria-controls="application"
                            >
                              Sub Category
                            </a>
                          </div>

                          <div
                            id="application"
                            className="collapse mt-1"
                            aria-labelledby="applicationHead"
                            data-parent="#productsType"
                          >
                            <div className="card-body">
                              <div className="custom-control custom-checkbox custom-checkbox-blue">
                                <input
                                  type="checkbox"
                                  className="custom-control-input custom-control-input-blue"
                                  id="customCheck3"
                                />
                                <label
                                  className="custom-control-label pt-1"
                                  for="customCheck3"
                                >
                                  1.5 Hour Rated Fire Dampers
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="card">
                          <div className="card-header" id="materialHead">
                            <a
                              href="#"
                              className="btn btn-header-link collapsed"
                              data-toggle="collapse"
                              data-target="#material"
                              aria-expanded="true"
                              aria-controls="material"
                            >
                              Type
                            </a>
                          </div>

                          <div
                            id="material"
                            className="collapse mt-1"
                            aria-labelledby="materialHead"
                            data-parent="#productsType"
                          >
                            <div className="card-body">
                              <div className="custom-control custom-checkbox custom-checkbox-blue">
                                <input
                                  type="checkbox"
                                  className="custom-control-input custom-control-input-blue"
                                  id="customCheck5"
                                />
                                <label
                                  className="custom-control-label pt-1"
                                  for="customCheck5"
                                >
                                  1.5 Hour Rated Fire Dampers
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-xxl-9 col-xl-9 col-lg-9 col-md-9 col-sm-12 col-xs-12 right-table-column">
                    <div>
                      <h5>Download Center</h5>
                    </div>
                    {/* <!-- table-sec starts --> */}
                    <div className="table-responsive mt-3">
                      <table className="table table-striped table-borderless">
                        <thead>
                          <tr>
                            <th scope="col">Image</th>
                            <th scope="col">Title</th>
                            <th scope="col">Model</th>
                            <th scope="col">Category</th>
                            <th scope="col">Sub Category</th>
                            <th scope="col">Type</th>
                            <th scope="col" className="text-center">
                              Action
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>
                              <img src={product}></img>
                            </td>
                            <td>Static Curtain fire damper</td>
                            <td>M119</td>
                            <td>Life Safety Dampers</td>
                            <td>Dampers</td>
                            <td>Product Data</td>
                            <td className="text-center">
                              <span>
                                <i class="fas fa-download"></i>
                              </span>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <img src={product}></img>
                            </td>
                            <td>Static Curtain fire damper</td>
                            <td>M119</td>
                            <td>Life Safety Dampers</td>
                            <td>Dampers</td>
                            <td>Product Data</td>
                            <td className="text-center">
                              <span>
                                <i class="fas fa-download"></i>
                              </span>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    {/* <!-- table-sec ends --> */}
                  </div>
                </div>
                {/* pagination-sec start */}
                <section className="pagination-sec">
                  <div className="row">
                    <div className="col-md-12">
                      <div className="pagination-d-flex">
                        <div className="d-flex justify-content-end align-items-baseline">
                          <p className="mr-2">Show</p>
                          <select className="form-control">
                            <option selected value="10">
                              1
                            </option>
                            <option value="2">2</option>
                          </select>
                        </div>
                        <nav
                          aria-label="Page navigation example"
                          className="ml-4"
                        >
                          <ul className="pagination">
                            <li className="page-item">
                              <a
                                className="page-link"
                                href="#"
                                aria-label="Previous"
                              >
                                <span aria-hidden="true">&laquo;</span>
                                <span className="sr-only">Previous</span>
                              </a>
                            </li>
                            <li className="page-item">
                              <a className="page-link active" href="#">
                                1
                              </a>
                            </li>
                            <li className="page-item">
                              <a className="page-link" href="#">
                                2
                              </a>
                            </li>
                            <li className="page-item">
                              <a className="page-link" href="#">
                                3
                              </a>
                            </li>
                            <li className="page-item">
                              <a
                                className="page-link"
                                href="#"
                                aria-label="Next"
                              >
                                <span aria-hidden="true">&raquo;</span>
                                <span className="sr-only">Next</span>
                              </a>
                            </li>
                          </ul>
                        </nav>
                      </div>
                    </div>
                  </div>
                </section>
                {/* pagination-sec end */}
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* <!-- filter-area-sec ends --> */}
      {/* <!-- Not Found--> */}
      <NotFound />
    </div>
  );
};

export default ProductMasterList;
